module.exports = __webpack_public_path__ + "img/loading.62d43359.svg";